import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  shouldShowBrandLight,
  shouldShowCartLight,
  shouldShowHamburgerLight,
  shouldShowNavigation,
} from '../navigation/utils.navigation';

const useHeader = () => {
  const history = useHistory();
  const [showHeader, setShowHeader] = useState(true);
  const [showHamburgerLight, setShowHamburgerLight] = useState(false);
  const [showBrandLight, setShowBrandLight] = useState(true);
  const [showCartLight, setShowCartLight] = useState(true);

  const setStateVariables = (history) => {
    const shouldShowHeader = shouldShowNavigation(history);
    setShowHeader(shouldShowHeader);

    const bShowHamburgerLight = shouldShowHamburgerLight(history);
    setShowHamburgerLight(bShowHamburgerLight);

    const bShowBrandLight = shouldShowBrandLight(history);
    setShowBrandLight(bShowBrandLight);

    const bShowCartLight = shouldShowCartLight(history);
    setShowCartLight(bShowCartLight);
  };

  useEffect(() => {
    return history.listen(() => {
      setStateVariables(history);
    });
  }, [history]);

  // If we first come to a page (like /cart or /checkout), the above useEffect won't run because it runs only when the path CHANGES. So, we need this for first time run. This can happen when we click on cart, checkout and are asked to login. This redirects us to google and comes back to our page which is equal to a 'first time run'
  useEffect(() => {
    setStateVariables(history);
  }, []);

  return { showHeader, showHamburgerLight, showBrandLight, showCartLight };
};

export default useHeader;
